<div class="overlay-warning-session" [ngClass]="{'active': isOpen}">
    <div class="warning-session" [ngClass]="{'active': isOpen}">
        <label class="timer">{{ 'GLOBAL.SESSION.EXPIRE' | translate }} <span>{{time}}</span></label>
        <label>{{ 'GLOBAL.SESSION.CONFIRM_QUESTION' | translate }}</label>
        <button class="mat-focus-indicator mat-flat-button mat-button-base mat-primary ng-star-inserted"
        (click)="close()">
        {{ 'GLOBAL.SESSION.CONFIRM' | translate }}
        </button>
    </div>
</div>